<div class="d-flex flex-column min-vh-100">

  <!-- <div class="pubblicita-skin"></div> -->
  @if (isShowBanner) {
    <div class="pubblicita-skin">
      <i class="fa-solid fa-x close-banner" (click)="isShowBanner = false"></i>
      <a href="https://www.milanofinanza.it/abbonamenti?utm_source=skin&utm_medium=mf+wsj+barrons&utm_campaign=campagnaconversione" target="_blank" aria-label="MilanoFinanza - Anticipa i mercati">
        <img src="./assets/imgs/compressed/milanofinanza-wsj-barrons-abbonamento.webp" alt="MilanoFinanza - Anticipa i mercati" loading="eager" [width]="getImgWidth()" [height]="getImageHeight()" />
      </a>
    </div>
  }

  <header>
    
    <!-- <app-header></app-header> -->
    <app-menu></app-menu>
    
  </header>
  <main class="flex-fill main-content">

    <app-panels>
      <router-outlet></router-outlet>
    </app-panels>

    <!-- <router-outlet></router-outlet> -->
  </main>
  <footer class="mt-auto footer">
    <app-footer></app-footer>
  </footer>
</div>
